import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
var StyledCoupon = styled.mark.withConfig({
  displayName: "Coupon__StyledCoupon",
  componentId: "j40qmb-0"
})(["display:inline;background:none;font-size:", ";letter-spacing:0.75px;text-transform:uppercase;border:1px dashed ", ";padding:2px ", ";line-height:inherit;font-weight:", ";border-radius:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.fontSizeTextSmall;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.paletteInkLighter;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.spaceXXSmall;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.fontWeightMedium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.paletteInkNormal;
});
StyledCoupon.defaultProps = {
  theme: defaultTheme
};

var Coupon = function Coupon(_ref7) {
  var children = _ref7.children,
      dataTest = _ref7.dataTest;
  return React.createElement(StyledCoupon, {
    "data-test": dataTest
  }, children);
};

export default Coupon;